import { Component, Inject } from '@angular/core';

@Component({
    selector: 'policy-engine-menu',
    template: require('./policy-engine-menu.component.html'),
    styles: [require('./policy-engine-menu.component.scss')]
})
export class PolicyEngineMenuComponent {

    // @Output() public onTabChange = new EventEmitter();

    public titles = [
        { name: 'Rules', state: 'app.authorized.policyEngine.rulesManagement' },
        { name: 'Policies', state: 'app.authorized.policyEngine.policyManagement' },
        { name: 'Policy Enforcement', state: 'app.authorized.policyEngine.policyEnforcement' }
    ];

    constructor(@Inject('$state') public $state: any) {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/policyEngine/policy-engine-menu/policy-engine-menu.component.ts